<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="退款查询" name="first">
        <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
          <el-form-item  prop="iccid">
            <el-input v-model="queryParams.iccid" placeholder="ICCID"  @keyup.enter.native="search" clearable></el-input>
          </el-form-item>
          <el-form-item prop="orderNum">
            <el-input v-model="queryParams.orderNum" placeholder="商户单号"  @keyup.enter.native="search" clearable></el-input>
          </el-form-item>
          <el-form-item  prop="refundStatus">
            <el-select v-model="queryParams.refundStatus" filterable placeholder="退款状态" @change="search" clearable>
              <el-option v-for="item in operator" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  prop="mode" >
            <el-select v-model="queryParams.mode" filterable placeholder="类型" @change="search" clearable>
              <el-option v-for="item in choiceType" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  prop="mchId" >
            <el-select v-model="queryParams.mchId" filterable placeholder="收款账号"  @change="search" clearable v-if="adminShow">
              <el-option v-for="item in mchSources" :key="item.mchId" :label='item.mchId + "-" + item.name' :value="item.mchId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  prop="refundPerson" >
            <el-input v-model="queryParams.refundPerson" placeholder="申请人"  @keyup.enter.native="search" clearable v-if="adminShow"></el-input>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="dateRange"
              style="width: 240px"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
            <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
        <div style="margin-top: 10px">
          <el-table :data="tableData" border>
            <el-table-column prop="iccid" label="ICCID" align="center" width="185px">
              <template slot-scope="scope">
                <div style="color: #4466AD;cursor: pointer;text-decoration: underline;" class="complaint-class" @click="jumpCardDetails(scope.row.iccid)">{{ scope.row.iccid }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="orderNum" label="商户单号" align="center" width="230px">
              <template slot-scope="scope" >
                <div @click="JumpDetails(scope.row.orderNum)" style="cursor: pointer;" v-if="adminShow">{{ scope.row.orderNum }}</div>
                <div v-else>{{ scope.row.orderNum }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="refundStatus" label="退款状态" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.refundStatus == '0'">待退款</span>
                <span v-else-if="scope.row.refundStatus == '1'">退款中</span>
                <span v-else-if="scope.row.refundStatus == '2'">退款完成</span>
                <span v-else>退款失败</span>
              </template>
            </el-table-column>
            <el-table-column prop="refundAmount" label="退款金额" align="center"></el-table-column>
            <el-table-column prop="mchId" label="收款账号" align="center" v-if="adminShow"></el-table-column>
            <el-table-column prop="mchName" label="收款账号名称" align="center" v-if="adminShow"></el-table-column>
            <el-table-column prop="refundPerson" label="申请人" align="center"></el-table-column>
            <el-table-column prop="type" label="类型" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.type == '1'">原路退回</span>
                <span v-else>线下</span>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="退款原因" align="center"></el-table-column>
            <el-table-column prop="createTime" label="提交时间" align="center"></el-table-column>
            <el-table-column prop="finishTime" label="结束时间" align="center"></el-table-column>
          </el-table>
        </div>
        <div class="block" style="margin-top: 30px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="申请退款" name="second">
        <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" :rules="rules">
          <el-form-item label="支付订单号：" prop="orderNum" label-width="140px">
            <el-input  placeholder="请输入支付订单号" style="width:270px" v-model.trim="ruleForm.orderNum" clearable></el-input>
          </el-form-item>
          <el-form-item style="margin-left: 140px;">
            <el-button type="primary" size="medium" @click="submitForm()">申请退款</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { refundDetail } from "@/api/api.js"; //退款的详情
import { refundList } from "@/api/api.js"; //退款列表
import { payConfigSource } from "@/api/api.js"; //收款账号
export default {
  name:"refundList",
  data() {
    return{
      activeName:"first",
      queryParams:{
        iccid:undefined,
        orderNum:undefined,
        refundStatus:undefined,
        mode:undefined,
        mchId:undefined,
        refundPerson:undefined
      },
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      dateRange:[],
      operator:[
        { value: 0, label: "待退款" },
        { value: 1, label: "退款中" },
        { value: 2, label: "退款完成 " },
        { value: 3, label: "退款失败" },
      ],
      choiceType:[
        { value: 1, label: "原路退回" },
        { value: 0, label: "线下" },
      ],
      mchSources:[],
      ruleForm:{},
      rules:{
        orderNum: [
          { required: true, message: "请输入微信支付订单号", trigger: "blur" }
        ],
      }
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        model:{
					... this.addDateRange(this.queryParams, this.dateRange),
				},
        page: this.page,
        pageSize: this.pageSize,
      };
      refundList(params).then(res=>{
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 跳转iccid详情
    jumpCardDetails(iccid){
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    },
    // 跳转退款详情
    JumpDetails(orderNum){
      this.$router.push({path:"/order/refundDetail",query:{orderNum: orderNum}});
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.initData();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    handleClick(tab, event) {
      this.$refs.ruleForm.clearValidate();
    },
    // 申请退款的详情
    submitForm(){
      let params = {
        orderNum:this.ruleForm.orderNum
      }
      refundDetail(params).then(res=>{
        if (res.data.code == 200) {
          this.$router.push({path:"/order/refundDetail",query:{orderNum: this.ruleForm.orderNum}});
        }else{
          this.$message.error("请输入正确的支付订单号");
        }
      })
    },
    //获取所有支付商号
    mchSource(){
      payConfigSource({}).then(res=>{
        this.mchSources = res.data.data;
       })
    }
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    },
    username:{
      get() {
          return this.$store.getters.name
      }
    }
  },
  mounted() {
    this.initData();
  },
  created() {
    this.mchSource();
  }
};
</script>
<style scoped lang="less">
.searchOne{
  display: inline-block;
  .el-input{
    margin-right: 30px;
    width:210px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
  }
  .el-date-editor{
    width:450px ;
  }
}
.rotating {
  transform: rotate(90deg);
}
.el-button--small.icon-button-auto {
  padding: 12px 9px;
  position: relative;
  top: -1px;
}
.span-but{
  margin-left: -30px;
  button{
    padding: 10px 20px;
    margin-top: 3px;
    margin-left: 5px;
  }
}
.array-class{
  width: 70%;
  display: flex;
  flex-wrap:wrap;
  margin-top: 5px;
  .el-input{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-date-editor{
    width:450px ;
    margin-top: 15px;
    margin-right: 30px;
  }
}
.demo-ruleForm{
  margin-top: 10px;
}
</style>


